import Base from "@/models/Base"
import type { IValueAndUnit } from "@/interfaces/IValueAndUnit"
import type { IEquipmentDimensionSpecifications } from '@/interfaces/equipments/IEquipmentDimensionSpecifications'

class EquipmentDimensionSpecifications extends Base implements IEquipmentDimensionSpecifications {
  width: IValueAndUnit<number>
  height: IValueAndUnit<number>
  length: IValueAndUnit<number>
  weight: IValueAndUnit<number>

  constructor(equipmentDimensionSpecifications?: any) {
    super(equipmentDimensionSpecifications)
    this.width = equipmentDimensionSpecifications?.width
    this.height = equipmentDimensionSpecifications?.height
    this.length = equipmentDimensionSpecifications?.length
    this.weight = equipmentDimensionSpecifications?.weight
  }
}

export default EquipmentDimensionSpecifications
